import { Component } from 'react';

import { Button } from '@iwoca/orion';
import { RootState } from '@iwProvider/configureStore';
import _ from 'lodash';
import { FormattedMessage } from 'react-intl';
import { connect } from 'react-redux';

import messages from './IdCheckVerificationModal.messages';
import styles from './IdCheckVerificationModal.module.css';
import PeopleToVerify from './peopleToVerify/PeopleToVerify';

const mapStateToProps = (state: RootState) => state.idCheckVerificationModal;

type PropsFromRedux = ReturnType<typeof mapStateToProps>;

class IdCheckVerificationModal extends Component<
    { onClose?: () => void } & PropsFromRedux
> {
    render() {
        const hasMultiplePeopleToVerify = this.props.peopleToVerify.length > 1;
        const id_verification_provider_name =
            this.props.id_verification_provider_name;

        return (
            <div className={styles.IdCheckVerificationModal}>
                <div className={styles.title}>
                    <FormattedMessage {...messages.title} />
                </div>
                <div className={styles.subTitle}>
                    {!hasMultiplePeopleToVerify ? (
                        <FormattedMessage
                            {...messages.subTitle}
                            values={{ id_verification_provider_name }}
                        />
                    ) : (
                        <FormattedMessage
                            {...messages.subTitleMultiple}
                            values={{ id_verification_provider_name }}
                        />
                    )}
                </div>
                <div className={styles.requirementsSubTitle}>
                    {!hasMultiplePeopleToVerify ? (
                        <FormattedMessage {...messages.requirementsSubTitle} />
                    ) : (
                        <FormattedMessage
                            {...messages.requirementsSubTitleMultiple}
                        />
                    )}
                </div>

                <PeopleToVerify />

                <div
                    className={styles.infoMessage}
                    data-testid="onfido-status-info"
                >
                    {this.renderInfoMessage()}
                </div>

                <div>
                    <Button
                        className={styles.proceedButton}
                        onClick={this.props.onClose}
                    >
                        <FormattedMessage
                            tagName="strong"
                            {...messages.continueText}
                        />
                    </Button>
                </div>
            </div>
        );
    }

    renderInfoMessage() {
        const { peopleToVerify, reachedMaxIdCheckAttempts } = this.props;

        const hasMultiplePeopleToVerify = peopleToVerify.length > 1;

        let message;

        _.map(peopleToVerify, (person) => {
            const hasSMSFailed = person.status === 'SMS failed';

            if (hasSMSFailed) {
                return (message = <FormattedMessage {...messages.smsFailed} />);
            }

            if (reachedMaxIdCheckAttempts) {
                return (message = (
                    <FormattedMessage
                        {...messages.reachedMaxOnfidoChecks}
                        values={{
                            phoneNumber: (
                                <FormattedMessage
                                    tagName="strong"
                                    {...messages.phoneNumber}
                                />
                            )
                        }}
                    />
                ));
            }

            if (
                person.idCheckStatus === 'Something went wrong' &&
                !hasSMSFailed
            ) {
                message = (
                    <FormattedMessage {...messages.somethingWentWrongInfo} />
                );
            }

            if (
                person.idCheckStatus === 'Not started yet' &&
                !hasMultiplePeopleToVerify
            ) {
                message = (
                    <FormattedMessage
                        {...messages.makeSureAllTextsSentInfo}
                        values={{
                            phoneNumber: (
                                <span>
                                    <FormattedMessage
                                        tagName="strong"
                                        {...messages.phoneNumber}
                                        values={{
                                            phoneNumber: (
                                                <FormattedMessage
                                                    tagName="strong"
                                                    {...messages.phoneNumber}
                                                />
                                            )
                                        }}
                                    />
                                </span>
                            )
                        }}
                    />
                );
            }

            if (
                person.idCheckStatus === 'Not started yet' &&
                hasMultiplePeopleToVerify
            ) {
                message = (
                    <FormattedMessage
                        {...messages.makeSureAllTextsSentInfoMultiple}
                        values={{
                            phoneNumber: (
                                <FormattedMessage
                                    tagName="strong"
                                    {...messages.phoneNumber}
                                />
                            )
                        }}
                    />
                );
            }

            if (_.includes(person.idCheckStatus, 'Verifying')) {
                message = (
                    <FormattedMessage
                        {...messages.makeSureAllTextsSentInfoMultiple}
                        values={{
                            phoneNumber: (
                                <FormattedMessage
                                    tagName="strong"
                                    {...messages.phoneNumber}
                                />
                            )
                        }}
                    />
                );
            }
        });
        return message;
    }
}

// eslint-disable-next-line import/no-default-export
export default connect(mapStateToProps)(IdCheckVerificationModal);
